import type { Theme } from '@mui/material';
import type { CSSObject } from 'tss-react';

export const PSEUDOELEMENT_ACTIVE_BORDER_BASE = (theme: Theme): CSSObject => ({
  content: '""',
  position: 'absolute',
  background: theme.palette.primary.main,
  zIndex: 1,
});
